/**
 * Load the Orange configuration for a given page.
 *
 */
export async function loadOrangeConfig(orangePageId: string) {
	await window.ADGW?.loadConfig(`via_${orangePageId}`);
}
